module.exports = __webpack_public_path__ + "static/media/SocialStudio.4ee0edd8.svg";